module.exports = __webpack_public_path__ + "static/media/coingecko.b104478b.png";